export default __webpack_public_path__ + "static/media/derby.6d912119.svg";